import(/* webpackMode: "eager" */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MainLayout"] */ "C:\\xampp\\htdocs\\enthioshub\\enthioshub\\frontend\\src\\components\\layout\\MainLayout.tsx");
